export default __webpack_public_path__ + "static/media/project1.9cb42d60.jpg";